<template>
    <div>
        <div class="hidden sm:block relative py-6">
            <div class="flex justify-center">
                <img class="logo-size" src="../../../assets/logo/tipcoin-logo-top.png">
            </div>
            <ProfileLogin :modalController="modalController"></ProfileLogin>
        </div>
        <div v-if="!isShowOnlyLogo" class="block sm:hidden relative mobile-top">
            <div class="flex justify-center">
                <div class="text-24 text-white pt-5">
                    {{title}}
                </div>
            </div>
            <div class="absolute left-7 top-2">
                <img class="logo-mobile-size" src="../../../assets/logo/tipcoin-logo-top.png">
            </div>
            <div class="absolute right-3 top-2 text-center text-white">
                <div class="text-18">{{lbl.topbar.coin}}</div>
                <div class="flex items-center">
                    <div class="text-24">{{FilterNumberFormat(profile && profile.updated_points? profile.updated_points.points : 0)}}</div>
                    <div><img class="w-3 ml-2" src="../../../assets/icon/icon-tipcoin.png"></div>
                </div>
            </div>
        </div>
        <div v-else class="block sm:hidden relative mobile-top pb-4 pt-2">
            <div class="flex justify-center">
                <img class="logo-mobile-size" src="../../../assets/logo/tipcoin-logo-top.png">
            </div>
        </div>
    </div>
</template>
<script>
import ProfileLogin from "./component/ProfileLogin.vue"
import AuthStatusMixin from "@/mixin/AuthStatusMixin";
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    name: 'TopBar',
    mixins: [AuthStatusMixin, LocaleMixin],
    components: {
        ProfileLogin,
    },
    props: {
        title: { type: String, default: '' },
        isShowOnlyLogo: { type: Boolean, default: false },
        modalController: { type: Object, required: true },
    },
    methods:{
        // AuthStatusMixin
        onAccountInit: function() {
            if (this.isLogin) {
                // console.log('profile', this.profile);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .logo-size {
        width: 100px;
        height: 90px;
    }
    .logo-mobile-size {
        width: 65px; //53px
        height: 58px;
    }
    .mobile-top {
        height: $topbar-height-mobile;
    }
</style>
